const Home = () => <h1>About</h1>
export default Home;